import { useTranslation } from "react-i18next";
import type { PackProgress } from "../lib/packProgress";

/**
 * Compact "X of Y mastered" bar for an installed pack, shared by the
 * Dashboard's installed-packs section and the Library catalog so the two
 * can't show different numbers for the same pack.
 */
export function PackProgressBar({ progress, className = "" }: { progress: PackProgress; className?: string }) {
  const { t } = useTranslation();
  const pct = progress.total > 0 ? Math.round((progress.mastered / progress.total) * 100) : 0;
  return (
    <div className={className}>
      <div className="h-1.5 w-full rounded-full bg-slate-100 dark:bg-slate-800 overflow-hidden">
        <div
          className="h-full rounded-full bg-emerald-500 transition-all duration-300"
          style={{ width: `${pct}%` }}
        />
      </div>
      <div className="text-xs text-slate-400 mt-1">
        {t("packList.progressLabel", { mastered: progress.mastered, total: progress.total })}
      </div>
    </div>
  );
}
